import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import styles from './styles.css';

const ErrorConexionVideoLlamada = props => {
  function redirectToConsultaTurno() {
    console.log('redirectToConsultaTurno');
  }

  function redirectToValidacionesTecnicas() {
    console.log(props.reconectar);
  }

  return (
    <div className={styles.root}>
      <div className="row">
        <div className="col-md-12">
          <p>
            Ocurri&oacute; un error al conectar con tu m&eacute;dico. Para
            volver a intentarlo por favor
            <br /> hac&eacute;
            <a
              onClick={redirectToValidacionesTecnicas}
              className={styles.btnClickForward}
              data-toggle="tooltip"
              role="button"
              data-placement="bottom"
            >
              <b> click aqui </b>
              >
              <b> click aqui </b>
            </a>
            o ingres&aacute; desde
            <a
              className={styles.btnClickForward}
              onClick={redirectToConsultaTurno}
              role="button"
            >
              >
              <b> Consulta de Turnos</b>
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(ErrorConexionVideoLlamada);



// WEBPACK FOOTER //
// ./src/routes/telemedicina/ErrorConexionVideoLlamada/ErrorConexionVideoLlamada.js